module.exports = __webpack_public_path__ + "img/close-red.c19b57f3.svg";